import React, { useState } from 'react'
import { Check } from 'react-feather'
import { FormattedMessage, useIntl } from 'react-intl'
import { FormGroup, Label, Button, Input } from 'reactstrap'
import '../../assets/scss/pages/authentication.scss'
import CheckBox from '../../components/Checkbox'
import { Formik, Field, Form } from 'formik'
import * as Yup from 'yup'
import BaseFormGroup from '../../components/BaseFormGroup.js'
import { NAME_REGEX, PHONE_REGEX } from '../../configs/app-configs'
import { register } from '../../redux/actions/auth'
import { useDispatch } from 'react-redux'

const formSchema = Yup.object().shape({
  fullName: Yup.string()
    .required(<FormattedMessage id='register.fullname.required' />)
    .matches(NAME_REGEX, () => (
      <FormattedMessage id='register.fullname.invalid' />
    )),
  email: Yup.string()
    .required(<FormattedMessage id='register.email.required' />)
    .email(<FormattedMessage id='register.email.invalid' />),
  phoneNumber: Yup.string()
    .matches(PHONE_REGEX, () => (
      <FormattedMessage id='register.phoneNumber.invalid' />
    ))
    .required(<FormattedMessage id='register.phoneNumber.required' />),
  refCode: Yup.string()
    .length(10, () => <FormattedMessage id='register.refCode.invalid' />)
    .matches(PHONE_REGEX, () => (
      <FormattedMessage id='register.refCode.invalid' />
    ))
})

const Register = () => {
  const [isAppcepted, setIsAppcepted] = useState(false)
  const [isNotApccepted, setIsNotAccepted] = useState(false)
  const dispatch = useDispatch()

  const intl = useIntl()
  const onSubmit = async (values) => {
    if (!isAppcepted) {
      setIsNotAccepted(true)
      return
    }
    dispatch(register(values))
  }

  const ontoggleAccepted = (checked) => {
    setIsAppcepted(checked)
    setIsNotAccepted(!checked)
  }

  const onChangeFullName = (e, form) => {
    const value = e.target.value.replace(/[^\w\s]/gi, '')
    form.setFieldValue('fullName', value)
  }

  return (
    <Formik
      initialValues={{
        fullName: '',
        email: '',
        phoneNumber: '',
        refCode: ''
      }}
      onSubmit={onSubmit}
      validationSchema={formSchema}
    >
      {({ errors, touched }) => (
        <Form>
          <BaseFormGroup
            fieldName='fullName'
            errors={errors}
            touched={touched}
            messageId='register.fullname'
          />

          <BaseFormGroup
            fieldName='email'
            errors={errors}
            touched={touched}
            messageId='register.email'
          />
          <BaseFormGroup
            fieldName='phoneNumber'
            errors={errors}
            touched={touched}
            messageId='register.phoneNumber'
          />
          <BaseFormGroup
            fieldName='refCode'
            errors={errors}
            touched={touched}
            messageId='register.refCode'
          />
          <FormGroup>
            <div className='d-flex align-items-center'>
              <CheckBox
                color='primary'
                icon={<Check className='vx-icon' size={16} />}
                onChange={(e) => ontoggleAccepted(e.target.checked)}
                defaultChecked={isAppcepted}
              />
              <div>
                <FormattedMessage id='register.agreeWith' />{' '}
                <a className='text-primary'>
                  <FormattedMessage id='register.policyAndCondition' />
                </a>{' '}
                <FormattedMessage id='register.useService' />
              </div>
            </div>
            {isNotApccepted ? (
              <div className='text-danger'>
                <FormattedMessage id='register.mustAppcepted' />
              </div>
            ) : null}
            <div className='d-flex justify-content-center mt-2'>
              <Button color='primary' type='submit'>
                <FormattedMessage id='register' />
              </Button>
            </div>
          </FormGroup>
        </Form>
      )}
    </Formik>
  )
}

export default Register
